const SET_USER = 'setUser'
const LOGIN = 'login'
const ADMIN_LOGIN = 'admin_login'
const RESET_PASSWORD = 'reset_password'
const GET_USER_INFO = 'get_user_info'
const SET_MENU_LIST = 'set_menu_list'
const LOGOUT = 'logout'
const CLEAR_MENUS = 'clear_menus'

export default {
  SET_USER,
  LOGIN,
  ADMIN_LOGIN,
  RESET_PASSWORD,
  GET_USER_INFO,
  SET_MENU_LIST,
  LOGOUT,
  CLEAR_MENUS
}



// WEBPACK FOOTER //
// ./src/store/module/user/types.js